'use client';

import { memo } from 'react';

import { User } from '@/.gql/graphql';
import { Subscriber } from '@/src/components/user/Subscriber';

const styles = {
  wrapper: 'flex flex-col gap-4',
  title: 'text-base font-bold text-center mb-3',
};

interface SubscribersBlockProps {
  subscribers: Array<User>;
  title: string;
}

export const SubscribersBlock = memo(
  ({ subscribers, title }: SubscribersBlockProps) => (
    <>
      <div className={styles.title}>{title}</div>
      <div className={styles.wrapper}>
        {subscribers?.map(({ id, firstName, meIsSubscribed }) => (
          <Subscriber
            key={id}
            id={id}
            firstName={firstName}
            isSubscribed={meIsSubscribed}
          />
        ))}
      </div>
    </>
  ),
);
SubscribersBlock.displayName = 'SubscribersBlock';
